import request from '@/utils/request'

// basic information 客户信息
export const getCusInfo = params =>
  request.get(`/customer-api/customer/workflow/query/${params.id}`)
// css submit
export const getCssSubmit = params =>
  request.post(`/workflow-api/credit-css/apply`, params)
